/**
 * @generated SignedSource<<23e8076ada20430c1ad38f690abf8e43>>
 * @relayHash eccf1b7507512587da805ffde74743b0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e8eae95cec690e72b27e258e2cb6978c31bb054079024d658734088e31043cf1

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type TownsquareUpdateStateFilter = "ACTIVE" | "AT_RISK" | "CANCELLED" | "DONE" | "NO_UPDATE" | "OFF_TRACK" | "ON_TRACK" | "PAUSED" | "PENDING" | "%future added value";
export type GoalUpdatesListAggQuery$variables = {
  containerId: string;
  endDate?: AGG$DateTime | null | undefined;
  startDate?: AGG$DateTime | null | undefined;
  stateFilter?: TownsquareUpdateStateFilter | null | undefined;
};
export type GoalUpdatesListAggQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"GoalUpdatesListAgg">;
};
export type GoalUpdatesListAggQuery = {
  response: GoalUpdatesListAggQuery$data;
  variables: GoalUpdatesListAggQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDate"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDate"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "stateFilter"
},
v4 = {
  "kind": "Variable",
  "name": "containerId",
  "variableName": "containerId"
},
v5 = {
  "kind": "Variable",
  "name": "stateFilter",
  "variableName": "stateFilter"
},
v6 = {
  "kind": "Literal",
  "name": "first",
  "value": 10
},
v7 = [
  (v4/*: any*/),
  {
    "kind": "Variable",
    "name": "createdAfter",
    "variableName": "startDate"
  },
  {
    "kind": "Variable",
    "name": "createdBefore",
    "variableName": "endDate"
  },
  (v6/*: any*/),
  (v5/*: any*/)
],
v8 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v9 = {
  "kind": "ScalarField",
  "name": "id"
},
v10 = {
  "kind": "ScalarField",
  "name": "missedUpdate"
},
v11 = {
  "kind": "ScalarField",
  "name": "updateType"
},
v12 = {
  "kind": "ScalarField",
  "name": "name"
},
v13 = {
  "kind": "ScalarField",
  "name": "picture"
},
v14 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v15 = {
  "kind": "ScalarField",
  "name": "label"
},
v16 = {
  "concreteType": "TownsquareTargetDateRange",
  "kind": "LinkedField",
  "name": "dateRange",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "start"
    },
    {
      "kind": "ScalarField",
      "name": "end"
    }
  ]
},
v17 = [
  (v15/*: any*/),
  (v16/*: any*/)
],
v18 = {
  "kind": "ScalarField",
  "name": "value"
},
v19 = {
  "kind": "ScalarField",
  "name": "score"
},
v20 = [
  (v18/*: any*/),
  (v19/*: any*/)
],
v21 = [
  (v18/*: any*/),
  (v9/*: any*/)
],
v22 = {
  "kind": "ScalarField",
  "name": "type"
},
v23 = {
  "kind": "ScalarField",
  "name": "subType"
},
v24 = {
  "kind": "ScalarField",
  "name": "archived"
},
v25 = {
  "kind": "ScalarField",
  "name": "source"
},
v26 = {
  "kind": "ScalarField",
  "name": "time"
},
v27 = {
  "concreteType": "TownsquareMetricValue",
  "kind": "LinkedField",
  "name": "latestValue",
  "plural": false,
  "selections": [
    (v26/*: any*/),
    (v9/*: any*/)
  ]
},
v28 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  }
],
v29 = {
  "kind": "ScalarField",
  "name": "percentage"
},
v30 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v31 = {
  "kind": "ScalarField",
  "name": "summary"
},
v32 = [
  (v8/*: any*/),
  (v14/*: any*/),
  (v12/*: any*/),
  (v13/*: any*/),
  (v9/*: any*/)
],
v33 = {
  "kind": "ScalarField",
  "name": "description"
},
v34 = {
  "concreteType": "TownsquareUpdateNoteConnection",
  "kind": "LinkedField",
  "name": "updateNotes",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareUpdateNoteEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareUpdateNote",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v9/*: any*/),
            (v31/*: any*/),
            (v33/*: any*/),
            (v24/*: any*/)
          ]
        }
      ]
    }
  ]
},
v35 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isTownsquareHighlight"
},
v36 = [
  (v8/*: any*/),
  (v13/*: any*/),
  (v12/*: any*/),
  (v9/*: any*/)
],
v37 = {
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": (v36/*: any*/)
},
v38 = {
  "kind": "LinkedField",
  "name": "lastEditedBy",
  "plural": false,
  "selections": (v36/*: any*/)
},
v39 = {
  "kind": "ScalarField",
  "name": "lastEditedDate"
},
v40 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v41 = [
  (v30/*: any*/),
  {
    "concreteType": "TownsquareGoalState",
    "kind": "LinkedField",
    "name": "newState",
    "plural": false,
    "selections": [
      (v18/*: any*/),
      (v19/*: any*/),
      (v15/*: any*/)
    ]
  },
  (v31/*: any*/),
  {
    "kind": "LinkedField",
    "name": "creator",
    "plural": false,
    "selections": (v32/*: any*/)
  },
  (v34/*: any*/),
  {
    "concreteType": "TownsquareHighlightConnection",
    "kind": "LinkedField",
    "name": "highlights",
    "plural": false,
    "selections": [
      {
        "concreteType": "TownsquareHighlightEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v9/*: any*/),
              (v31/*: any*/),
              (v33/*: any*/),
              (v35/*: any*/),
              (v37/*: any*/),
              (v38/*: any*/),
              (v30/*: any*/),
              (v39/*: any*/)
            ]
          }
        ]
      },
      (v40/*: any*/)
    ]
  },
  (v9/*: any*/)
],
v42 = {
  "concreteType": "TownsquareMetricTargetConnection",
  "kind": "LinkedField",
  "name": "metricTargets",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareMetricTargetEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareMetricTarget",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v9/*: any*/),
            {
              "concreteType": "TownsquareMetric",
              "kind": "LinkedField",
              "name": "metric",
              "plural": false,
              "selections": [
                (v9/*: any*/),
                (v12/*: any*/),
                (v22/*: any*/),
                (v23/*: any*/),
                (v24/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "externalEntityId"
                },
                (v25/*: any*/),
                (v27/*: any*/)
              ]
            },
            {
              "concreteType": "TownsquareMetricValue",
              "kind": "LinkedField",
              "name": "snapshotValue",
              "plural": false,
              "selections": (v21/*: any*/)
            },
            {
              "kind": "ScalarField",
              "name": "startValue"
            },
            {
              "kind": "ScalarField",
              "name": "targetValue"
            }
          ]
        }
      ]
    }
  ]
},
v43 = {
  "kind": "ScalarField",
  "name": "url"
},
v44 = {
  "kind": "ScalarField",
  "name": "scoringMode"
},
v45 = {
  "concreteType": "TownsquareTargetDate",
  "kind": "LinkedField",
  "name": "targetDate",
  "plural": false,
  "selections": [
    (v16/*: any*/)
  ]
},
v46 = {
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": (v32/*: any*/)
},
v47 = {
  "kind": "ScalarField",
  "name": "editDate"
},
v48 = [
  (v9/*: any*/)
],
v49 = [
  (v18/*: any*/)
],
v50 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "messageId"
    },
    {
      "kind": "ScalarField",
      "name": "defaultValue"
    }
  ],
  "type": "TownsquareLocalizationField"
},
v51 = {
  "kind": "LinkedField",
  "name": "name",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v49/*: any*/),
      "type": "TownsquareGoalTypeCustomName"
    },
    (v50/*: any*/)
  ]
},
v52 = {
  "kind": "LinkedField",
  "name": "namePlural",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v49/*: any*/),
      "type": "TownsquareGoalTypeCustomNamePlural"
    },
    (v50/*: any*/)
  ]
},
v53 = {
  "concreteType": "TownsquareGoalProgress",
  "kind": "LinkedField",
  "name": "progress",
  "plural": false,
  "selections": [
    (v29/*: any*/),
    (v22/*: any*/)
  ]
},
v54 = {
  "concreteType": "TownsquareGoalUpdate",
  "kind": "LinkedField",
  "name": "latestUserUpdate",
  "plural": false,
  "selections": (v41/*: any*/)
},
v55 = {
  "kind": "ScalarField",
  "name": "isArchived"
},
v56 = {
  "kind": "ScalarField",
  "name": "key"
},
v57 = {
  "concreteType": "TownsquareGoalTypeIcon",
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": [
    (v56/*: any*/)
  ]
},
v58 = {
  "concreteType": "TownsquareStatus",
  "kind": "LinkedField",
  "name": "status",
  "plural": false,
  "selections": (v20/*: any*/)
},
v59 = [
  (v6/*: any*/)
],
v60 = [
  {
    "concreteType": "TownsquareGoalUpdateEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "TownsquareGoalUpdate",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          (v11/*: any*/),
          (v31/*: any*/),
          (v47/*: any*/),
          (v30/*: any*/),
          (v9/*: any*/)
        ]
      }
    ]
  }
],
v61 = {
  "kind": "ScalarField",
  "name": "kind"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "GoalUpdatesListAggQuery",
    "selections": [
      {
        "args": [
          (v4/*: any*/),
          {
            "kind": "Variable",
            "name": "endDate",
            "variableName": "endDate"
          },
          {
            "kind": "Variable",
            "name": "startDate",
            "variableName": "startDate"
          },
          (v5/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "GoalUpdatesListAgg"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "GoalUpdatesListAggQuery",
    "selections": [
      {
        "args": (v7/*: any*/),
        "concreteType": "TownsquareUpdateConnection",
        "kind": "LinkedField",
        "name": "goals_allWatchedGoalUpdates",
        "plural": false,
        "selections": [
          {
            "concreteType": "TownsquareUpdateEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "creator",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v9/*: any*/),
                          (v14/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "TownsquareTargetDate",
                        "kind": "LinkedField",
                        "name": "newDueDate",
                        "plural": false,
                        "selections": (v17/*: any*/)
                      },
                      {
                        "concreteType": "TownsquareGoalState",
                        "kind": "LinkedField",
                        "name": "newState",
                        "plural": false,
                        "selections": (v20/*: any*/)
                      },
                      {
                        "concreteType": "TownsquareGoalMetricUpdateConnection",
                        "kind": "LinkedField",
                        "name": "metricUpdate",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareGoalMetricUpdateEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalMetricUpdate",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareMetricValue",
                                    "kind": "LinkedField",
                                    "name": "newValue",
                                    "plural": false,
                                    "selections": (v21/*: any*/)
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "newStartValue"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "newTargetValue"
                                  },
                                  {
                                    "concreteType": "TownsquareMetric",
                                    "kind": "LinkedField",
                                    "name": "metric",
                                    "plural": false,
                                    "selections": [
                                      (v9/*: any*/),
                                      (v12/*: any*/),
                                      (v22/*: any*/),
                                      (v23/*: any*/),
                                      (v24/*: any*/),
                                      (v25/*: any*/),
                                      (v27/*: any*/),
                                      {
                                        "args": [
                                          {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 100
                                          },
                                          {
                                            "kind": "Literal",
                                            "name": "sort",
                                            "value": [
                                              "TIME_DESC"
                                            ]
                                          }
                                        ],
                                        "concreteType": "TownsquareMetricValueConnection",
                                        "kind": "LinkedField",
                                        "name": "values",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareMetricValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareMetricValue",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v18/*: any*/),
                                                  (v26/*: any*/),
                                                  (v9/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ],
                                        "storageKey": "values(first:100,sort:[\"TIME_DESC\"])"
                                      }
                                    ]
                                  },
                                  {
                                    "concreteType": "TownsquareMetricValue",
                                    "kind": "LinkedField",
                                    "name": "oldValue",
                                    "plural": false,
                                    "selections": (v21/*: any*/)
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "args": (v28/*: any*/),
                        "concreteType": "TownsquareGoalBundledUpdateConnection",
                        "kind": "LinkedField",
                        "name": "bundledUpdates",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareGoalBundledUpdateEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoal",
                                "kind": "LinkedField",
                                "name": "successMeasure",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalProgress",
                                    "kind": "LinkedField",
                                    "name": "progress",
                                    "plural": false,
                                    "selections": [
                                      (v29/*: any*/)
                                    ]
                                  },
                                  (v9/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "TownsquareGoalUpdate",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": (v41/*: any*/)
                              },
                              {
                                "kind": "ScalarField",
                                "name": "nodeMissingReason"
                              },
                              {
                                "concreteType": "TownsquareGoal",
                                "kind": "LinkedField",
                                "name": "goal",
                                "plural": false,
                                "selections": [
                                  (v9/*: any*/),
                                  (v12/*: any*/),
                                  {
                                    "concreteType": "TownsquareGoalProgress",
                                    "kind": "LinkedField",
                                    "name": "progress",
                                    "plural": false,
                                    "selections": [
                                      (v22/*: any*/),
                                      (v29/*: any*/)
                                    ]
                                  },
                                  (v42/*: any*/),
                                  (v43/*: any*/),
                                  (v44/*: any*/),
                                  (v45/*: any*/),
                                  (v46/*: any*/)
                                ]
                              }
                            ]
                          }
                        ],
                        "storageKey": "bundledUpdates(first:50)"
                      },
                      {
                        "kind": "LinkedField",
                        "name": "lastEditedBy",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v14/*: any*/),
                          (v12/*: any*/),
                          (v9/*: any*/)
                        ]
                      },
                      (v30/*: any*/),
                      (v47/*: any*/),
                      (v43/*: any*/),
                      {
                        "concreteType": "GraphStoreSimplifiedUserViewedGoalUpdateInverseConnection",
                        "kind": "LinkedField",
                        "name": "viewers",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "GraphStoreSimplifiedUserViewedGoalUpdateInverseEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v8/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v9/*: any*/),
                                      (v12/*: any*/),
                                      (v14/*: any*/),
                                      (v13/*: any*/)
                                    ],
                                    "type": "AtlassianAccountUser"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v48/*: any*/),
                                    "type": "AppUser"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v48/*: any*/),
                                    "type": "CustomerUser"
                                  }
                                ]
                              },
                              (v9/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v31/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "newTargetDate"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "newTargetDateConfidence"
                      },
                      (v34/*: any*/),
                      {
                        "concreteType": "TownsquareHighlightConnection",
                        "kind": "LinkedField",
                        "name": "highlights",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareHighlightEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v31/*: any*/),
                                  (v33/*: any*/),
                                  (v8/*: any*/),
                                  (v9/*: any*/),
                                  (v35/*: any*/),
                                  (v37/*: any*/),
                                  (v38/*: any*/),
                                  (v30/*: any*/),
                                  (v39/*: any*/)
                                ]
                              }
                            ]
                          },
                          (v40/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "TownsquareGoal",
                        "kind": "LinkedField",
                        "name": "goal",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v44/*: any*/),
                          (v24/*: any*/),
                          {
                            "concreteType": "TownsquareGoalType",
                            "kind": "LinkedField",
                            "name": "goalType",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalType",
                                "kind": "LinkedField",
                                "name": "successMeasure",
                                "plural": false,
                                "selections": [
                                  (v51/*: any*/),
                                  (v52/*: any*/),
                                  (v9/*: any*/)
                                ]
                              },
                              (v9/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "TownsquareGoalProgress",
                            "kind": "LinkedField",
                            "name": "progress",
                            "plural": false,
                            "selections": [
                              (v22/*: any*/)
                            ]
                          },
                          {
                            "args": (v28/*: any*/),
                            "concreteType": "TownsquareGoalConnection",
                            "kind": "LinkedField",
                            "name": "successMeasures",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoal",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v9/*: any*/),
                                      (v12/*: any*/),
                                      (v24/*: any*/),
                                      (v53/*: any*/),
                                      (v42/*: any*/),
                                      (v43/*: any*/),
                                      (v44/*: any*/),
                                      (v45/*: any*/),
                                      (v46/*: any*/),
                                      (v54/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "uuid"
                                      },
                                      (v55/*: any*/),
                                      {
                                        "concreteType": "TownsquareGoalType",
                                        "kind": "LinkedField",
                                        "name": "goalType",
                                        "plural": false,
                                        "selections": [
                                          (v51/*: any*/),
                                          (v52/*: any*/),
                                          (v57/*: any*/),
                                          (v9/*: any*/)
                                        ]
                                      },
                                      (v58/*: any*/),
                                      {
                                        "args": (v59/*: any*/),
                                        "concreteType": "TownsquareGoalUpdateConnection",
                                        "kind": "LinkedField",
                                        "name": "updates",
                                        "plural": false,
                                        "selections": (v60/*: any*/),
                                        "storageKey": "updates(first:10)"
                                      }
                                    ]
                                  },
                                  (v8/*: any*/)
                                ]
                              }
                            ],
                            "storageKey": "successMeasures(first:50)"
                          },
                          {
                            "concreteType": "TownsquareGoalConnection",
                            "kind": "LinkedField",
                            "name": "subGoals",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoal",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v9/*: any*/),
                                      (v12/*: any*/),
                                      (v24/*: any*/),
                                      (v53/*: any*/),
                                      {
                                        "concreteType": "TownsquareGoalType",
                                        "kind": "LinkedField",
                                        "name": "goalType",
                                        "plural": false,
                                        "selections": [
                                          (v61/*: any*/),
                                          (v9/*: any*/)
                                        ]
                                      },
                                      (v42/*: any*/),
                                      (v43/*: any*/),
                                      (v44/*: any*/),
                                      (v45/*: any*/),
                                      (v46/*: any*/),
                                      (v54/*: any*/),
                                      (v55/*: any*/),
                                      {
                                        "concreteType": "TownsquareGoalType",
                                        "kind": "LinkedField",
                                        "name": "goalType",
                                        "plural": false,
                                        "selections": [
                                          (v61/*: any*/),
                                          (v57/*: any*/),
                                          (v9/*: any*/)
                                        ]
                                      },
                                      (v58/*: any*/),
                                      {
                                        "args": [
                                          {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 30
                                          }
                                        ],
                                        "concreteType": "TownsquareGoalUpdateConnection",
                                        "kind": "LinkedField",
                                        "name": "updates",
                                        "plural": false,
                                        "selections": (v60/*: any*/),
                                        "storageKey": "updates(first:30)"
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "args": (v59/*: any*/),
                            "concreteType": "TownsquareGoalUpdateConnection",
                            "kind": "LinkedField",
                            "name": "updates",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalUpdateEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalUpdate",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v9/*: any*/),
                                      (v31/*: any*/),
                                      {
                                        "concreteType": "TownsquareUpdateNoteConnection",
                                        "kind": "LinkedField",
                                        "name": "updateNotes",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareUpdateNoteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareUpdateNote",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v31/*: any*/),
                                                  (v33/*: any*/),
                                                  (v9/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ],
                            "storageKey": "updates(first:10)"
                          },
                          {
                            "concreteType": "TownsquareMetricTargetConnection",
                            "kind": "LinkedField",
                            "name": "metricTargets",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareMetricTargetEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareMetricTarget",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareMetric",
                                        "kind": "LinkedField",
                                        "name": "metric",
                                        "plural": false,
                                        "selections": [
                                          (v9/*: any*/),
                                          (v24/*: any*/)
                                        ]
                                      },
                                      (v9/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "isWatching"
                          },
                          {
                            "concreteType": "TownsquareGoalCapabilities",
                            "kind": "LinkedField",
                            "name": "capabilities",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "canWatchGoal"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "canCreateUpdates"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "canEditUpdates"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "canDeleteUpdates"
                              }
                            ]
                          },
                          {
                            "concreteType": "TownsquareGoal",
                            "kind": "LinkedField",
                            "name": "parentGoal",
                            "plural": false,
                            "selections": (v48/*: any*/)
                          },
                          (v56/*: any*/),
                          (v12/*: any*/),
                          {
                            "concreteType": "TownsquareGoalIcon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                              (v56/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "appearance"
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "canPostUpdate"
                          },
                          (v55/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "canEditUpdate"
                          },
                          {
                            "concreteType": "TownsquareGoalCapabilities",
                            "kind": "LinkedField",
                            "name": "capabilities",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "canCommentOnUpdates"
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "ari"
                      },
                      {
                        "concreteType": "TownsquareCommentConnection",
                        "kind": "LinkedField",
                        "name": "comments",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareCommentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareComment",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v9/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "name": "creator",
                                    "plural": false,
                                    "selections": [
                                      (v8/*: any*/),
                                      (v12/*: any*/),
                                      (v9/*: any*/),
                                      (v14/*: any*/),
                                      (v13/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "commentText"
                                  },
                                  (v47/*: any*/),
                                  (v30/*: any*/)
                                ]
                              }
                            ]
                          },
                          (v40/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "TownsquareGoalState",
                        "kind": "LinkedField",
                        "name": "oldState",
                        "plural": false,
                        "selections": (v20/*: any*/)
                      },
                      {
                        "concreteType": "TownsquareTargetDate",
                        "kind": "LinkedField",
                        "name": "oldDueDate",
                        "plural": false,
                        "selections": (v17/*: any*/)
                      }
                    ],
                    "type": "TownsquareGoalUpdate"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v48/*: any*/),
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "cursor"
              }
            ]
          },
          {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "endCursor"
              },
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              }
            ]
          }
        ]
      },
      {
        "args": (v7/*: any*/),
        "filters": [
          "containerId",
          "createdBefore",
          "createdAfter",
          "stateFilter"
        ],
        "handle": "connection",
        "key": "GoalUpdatesList_goals_allWatchedGoalUpdates",
        "kind": "LinkedHandle",
        "name": "goals_allWatchedGoalUpdates"
      }
    ]
  },
  "params": {
    "id": "e8eae95cec690e72b27e258e2cb6978c31bb054079024d658734088e31043cf1",
    "metadata": {},
    "name": "GoalUpdatesListAggQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "ad6847d15493f2ffbc8eb33a4c0a7155";

export default node;
